var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#0E0E0E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1260_8634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 49.9959C50.0005 45.3103 53.7989 41.5117 58.4847 41.5117C63.1703 41.5117 66.9688 45.3103 66.9688 49.9959C66.9688 54.6816 63.1703 58.4801 58.4847 58.4801C53.7989 58.4801 50.0005 54.6816 50.0005 49.9959Z",
    fill: "#008AFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 66.9681C33.0322 62.2825 36.8307 58.4839 41.5164 58.4839H50.0006V66.9681C50.0006 71.6538 46.2021 75.4522 41.5164 75.4522C36.8307 75.4522 33.0322 71.6538 33.0322 66.9681Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 24.5439V41.5122H58.4847C63.1704 41.5122 66.9688 37.7138 66.9688 33.0281C66.9688 28.3424 63.1704 24.5439 58.4847 24.5439H50.0005Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 33.0281C33.0322 37.7138 36.8307 41.5122 41.5164 41.5122H50.0006V24.5439H41.5164C36.8307 24.5439 33.0322 28.3424 33.0322 33.0281Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 49.9959C33.0322 54.6816 36.8307 58.4801 41.5164 58.4801H50.0006V41.5117H41.5164C36.8307 41.5117 33.0322 45.3103 33.0322 49.9959Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1260_8634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2857,
    height: 51.4286,
    fill: "white",
    transform: "translate(32.8574 24.2837)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.31afe297815f0cbf94d3bb1fe58b45dd.svg";
export { ForwardRef as ReactComponent };